import React, { useState } from 'react';
import { Card, Checkbox, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { dropdownSize, inputSize, textInputSize } from '../../../Shared/UI/jsx';
import { FormDescription } from '../../../Shared/Consts/FormDescription';
import { frequencyMinutes, frequencyOptions } from '../../../Shared/Consts/Dropdowns';

const { Item } = Form;
const { TextArea } = Input;
const {Option} = Select;

const Therapists = ({ form, formContext }) => {
    return (
        <Form
            form={form}
            size="small"
            layout="vertical"
        >
            <Row gutter={[8, 8]}>
                <Card title="Developmental Therapist" className='formCard'>
                    <Row>
                        {/* Developmental Therapist */}
                        <Col span={12}>
                            <Item name="dTServicesStartBy" label="DT Services Start By">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTInitialIFSPDateSOS" label="DT Initial IFSP SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTProviderSOSDate" label="DT Provider SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTDateAssigned" label="DT Date Assigned">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox disabled>
                                    DT Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="developmentalTherapistId" label="Developmental Therapist">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.DT ? (
                                <FormDescription description={formContext.DT.preferredName + " " + formContext.DT.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="dtFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtcId" label="DTC">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.DTC ? (
                                <FormDescription description={formContext.DTC.preferredName + " " + formContext.DTC.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="dtcFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtcFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dtcSupervisorId" label="DT Supervisor">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.DTSupervisor ? (
                                <FormDescription description={formContext.DTSupervisor.preferredName + " " + formContext.DTSupervisor.lastName} />
                            ) : null}
                        </Col>
                    </Row>
                </Card>
                {/* Occupational Therapist */}
                <Card title="Occupational Therapist" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="oTServicesStartBy" label="OT Services Start By">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTInitialIFSPDateSOS" label="OT Initial IFSP SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTProviderSOSDate" label="OT Provider SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTDateAssigned" label="OT Date Assigned">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="oTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox disabled>
                                    OT Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="occupationalTherapistId" label="Occupational Therapist">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.OT ? (
                                <FormDescription description={formContext.OT.preferredName + " " + formContext.OT.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="otFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="otFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="cotaId" label="COTA">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.COTA ? (
                                <FormDescription description={formContext.COTA.preferredName + " " + formContext.COTA.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="cotaFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="cotaFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    showSearch
                                    disabled
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="cotaSupervisorId" label="COTA Supervisor">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.COTA ? (
                                <FormDescription description={formContext.COTASupervisor.preferredName + " " + formContext.COTASupervisor.lastName} />
                            ) : null}
                        </Col>
                    </Row>
                </Card>
                {/* Physical Therapist */}
                <Card title="Physical Therapist" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="pTServicesStartBy" label="PT Services Start By">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTInitialIFSPDateSOS" label="PT Initial IFSP SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTProviderSOSDate" label="PT Provider SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTDateAssigned" label="PT Date Assigned">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="pTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox disabled>
                                    PT Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="physicalTherapistId" label="Physical Therapist">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.PT ? (
                                <FormDescription description={formContext.PT.preferredName + " " + formContext.PT.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="ptFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptaId" label="PTA">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.PTA ? (
                                <FormDescription description={formContext.PTA.preferredName + " " + formContext.PTA.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="ptaFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptaFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="ptaSupervisorId" label="PTA Supervisor">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.PTASupervisor ? (
                                <FormDescription description={formContext.PTASupervisor.preferredName + " " + formContext.PTASupervisor.lastName} />
                            ) : null}
                        </Col>
                    </Row>
                </Card>
                {/* Speech Therapist */}
                <Card title="Speech Therapist" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="sTServicesStartBy" label="ST Services Start By">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTInitialIFSPDateSOS" label="ST Initial IFSP SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTProviderSOSDate" label="ST Provider SOS">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTDateAssigned" label="ST Date Assigned">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="sTServiceFromAnotherAgency" valuePropName="checked">
                                <Checkbox disabled>
                                    ST Other Agency?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="speechTherapistId" label="Speech Therapist">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.SLP ? (
                                <FormDescription description={formContext.SLP.preferredName + " " + formContext.SLP.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="stFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="stFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="slpcfId" label="SLPCF">
                                <Input disabled style={inputSize}/>
                            </Item>
                            {formContext && formContext.SLPCF ? (
                                <FormDescription description={formContext.SLPCF.preferredName + " " + formContext.SLPCF.lastName} />
                            ) : null}
                        </Col>
                        <Col span={12}>
                            <Item name="slpcfFrequency" label="Frequency">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyOptions.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="slpcfFrequencyMinutes" label="Minutes">
                                <Select
                                    style={dropdownSize}
                                    disabled
                                    showSearch
                                    filterOption={(input, option) => 
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {frequencyMinutes.map(opt => (
                                        <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>    
                            </Item>
                        </Col>
                    </Row>
                </Card>
                <Card title="Reports" className='formCard'>
                    <Row>
                        <Col span={12}>
                            <Item name="quaterlyReport5Month" label="Quarterly Report - 5 month">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="quarterlyReport10Month" label="Quarterly Report - 10 month">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="otherReport" label="Other Report">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="dischargeReport" label="Discharge Report">
                                <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="exitSkills" label="Exit Skills">
                                <TextArea style={textInputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                            <Item name="notes" label="Notes">
                                <TextArea disabled style={textInputSize} />
                            </Item>
                        </Col>
                        <Col span={12}>
                        <Item name="checkNotes" valuePropName="checked">
                            <Checkbox disabled>
                                Check Notes?
                            </Checkbox>
                        </Item>
                    </Col>
                    </Row>
                </Card>
            </Row >
        </Form >
    )
}

export default Therapists;